// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const furret: PokeData = {
  "id": 162,
  "name": "furret",
  "height": 18,
  "weight": 325,
  "base_experience": 145,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "scratch",
    "slam",
    "double-edge",
    "growl",
    "agility",
    "quick-attack",
    "defense-curl",
    "amnesia",
    "fury-swipes",
    "rest",
    "reversal",
    "foresight",
    "baton-pass",
    "follow-me",
    "helping-hand",
    "hyper-voice",
    "me-first",
    "sucker-punch",
    "coil"
  ],
  "moves": [
    "scratch",
    "growl",
    "agility",
    "quick-attack",
    "hyper-voice",
    "leer",
    "tackle",
    "tri-attack",
    "protect",
    "supersonic",
    "headbutt",
    "splash",
    "refresh"
  ],
  "evolution_chain": {
    "id": 82,
    "item": null,
    "species": [
      {
        "name": "sentret",
        "order": 193,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "furret",
        "order": 194,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 161,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 15,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 121,
    "speed": 151,
    "ability_power": 128
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
